import { Switch } from "@mui/material";

import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";

export const pluginColumns = ["name", "status"];

export const getGroupPluginsColumns = (
	loading,
	togglePlugin
) => [
	{
		field: "name",
		headerName: "Name",
		editable: false,
		sortable: true,
		flex: .5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "status",
		headerName: "Status",
		editable: false,
		sortable: true,
		flex: 0.5,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={params.row.activeForGroup}
						disabled={params.row.active ? false : true}
						onChange={() => togglePlugin(params.row)}
					/>
				}
				isLoading={loading}
			/>
		),
	},
];